"use client";

import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
export default function Portfolionavigationtabs() {
  const [activeFilter, setActiveFilter] = useState("all");
  const filters = [{
    value: "all",
    label: "ALL"
  }, {
    value: "industrial",
    label: "INDUSTRIAL"
  }, {
    value: "automation",
    label: "AUTOMATION"
  }, {
    value: "manufacturing",
    label: "MANUFACTURING"
  }, {
    value: "logistics",
    label: "LOGISTICS"
  }];
  const deals = [{
    id: 1,
    client: "SOUTHERN STEEL",
    value: "COMPLETED",
    sector: "INDUSTRIAL",
    role: "SYSTEM INTEGRATION",
    status: "OPERATIONAL",
    category: "industrial",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_upgrade.png",
    alt: "Industrial facility upgrade project"
  }, {
    id: 2,
    client: "AUTO-TECH CORP",
    value: "COMPLETED",
    sector: "AUTOMATION",
    role: "ROBOTIC CELL",
    status: "OPERATIONAL",
    category: "automation",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/automation_robotic_cell.png",
    alt: "Automated robotic cell installation"
  }, {
    id: 3,
    client: "GLOBAL LOGISTICS",
    value: "COMPLETED",
    sector: "LOGISTICS",
    role: "CONVEYOR SYSTEM",
    status: "OPERATIONAL",
    category: "logistics",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/logistics_conveyor_system.png",
    alt: "Logistics conveyor system implementation"
  }, {
    id: 4,
    client: "PRECISION PARTS",
    value: "COMPLETED",
    sector: "MANUFACTURING",
    role: "CNC UPGRADE",
    status: "OPERATIONAL",
    category: "manufacturing",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/manufacturing_cnc_upgrade.png",
    alt: "Precision manufacturing CNC upgrade"
  }, {
    id: 5,
    client: "ENERGY SOLUTIONS",
    value: "COMPLETED",
    sector: "INDUSTRIAL",
    role: "POWER GRID",
    status: "OPERATIONAL",
    category: "industrial",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_power_grid.png",
    alt: "Industrial power grid infrastructure"
  }, {
    id: 6,
    client: "FAST-SHIP INC",
    value: "COMPLETED",
    sector: "LOGISTICS",
    role: "SORTING HUB",
    status: "OPERATIONAL",
    category: "logistics",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/logistics_sorting_hub.png",
    alt: "Logistics sorting hub facility"
  }];
  const filteredDeals = deals.filter(deal => {
    if (activeFilter === "all") return true;
    return deal.category === activeFilter;
  });
  return;
}